import api from '../../lib/api'
import assign from 'lodash.assign'
import login from '@/utils/login'
import global from '../../types/global.types'
const name = 'activity'

export default {
  name,
  namespaced: true,
  state: {
    bubbleShow: false,
    courseLists: [],
    userList: [],
    data: {},
    qrcode: '',
    isReceive: false
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async checkLogin () {
      const wpsSid = await login.getWpsSid()

      return wpsSid || login.login()
    },
    async 'data:get' ({ commit }) {
      const data = await api.data.get()
      commit('set', { data })
    },
    async getInfo ({ commit }) {
      try {
        const { data } = await api.activity.getInfo()
        commit('set', {
          courseLists: data.courseLists,
          userList: data.userList,
          isReceive: data.isReceive
        })
      } catch (e) {
        // commit(global.ERR, { message: '抱歉，获取信息出错，请稍后再试！' }, { root: true })
      }
    },
    async init ({ dispatch }) {
      console.log('init activity')
      await dispatch('checkLogin')
      await dispatch('getInfo')
      // await dispatch('data:get')
    },
    async receive ({ commit }, course) {
      try {
        const { data } = await api.activity.getQrcode(course.courseId)()
        if (data) {
          commit('set', { bubbleShow: true, qrcode: data })
        } else {
          commit(global.ERR, { message: '抱歉，获取二维码出错，请稍后再试！' }, { root: true })
        }
      } catch (e) {
        commit(global.ERR, { message: '抱歉，获取二维码出错，请稍后再试！' }, { root: true })
      }
    }
  }
}
